import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { createStore } from 'redux'
import { devToolsEnhancer } from 'redux-devtools-extension/developmentOnly'
import { Provider } from 'react-redux'

import reducer from './reducers'

const store = createStore(reducer, devToolsEnhancer({}))

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
